import { Form } from 'react-final-form'
import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import API from 'api'
// import { toast } from 'react-toastify'
import { autosuggestStyles } from '../utils'
import { connect } from 'react-redux'
import { setReviewAdded } from '../../../actions/dive-guide-actions'
import {
  FormDropDown,
  FormInput,
  FormCheckbox,
  FormTextArea,
} from '../../forms/final-form-fields'
import { addingReview } from './validations'
import { useEffect } from 'react'
import { connectCaptcha } from '../../../utils'
import { FORM_ERROR } from 'final-form'

const messages = defineMessages({
  namePlaceholder: {
    id: 'reviews.full_name',
    defaultMessage: 'Full name',
  },
  placeholder: {
    id: 'reviews.dive_site.tell_others',
    defaultMessage:
      'Tell people about your experience: describe the place, recommendations for visitors, the feelings you got...',
  },
  reviewAdded: {
    id: 'reviews.dive_site.review_added',
    defaultMessage: 'Review was successfully added',
  },
  certification: {
    id: 'reviews.dive_site.certification',
    defaultMessage: 'What is your highest level of certification?',
  },
  aggreement: {
    defaultMessage:
      'I certify that this review is based on my own experience and is my genuine opinion of this dive site.',
    id: 'reviews.dive_site.is_own_experience',
  },
  yourName: {
    id: 'reviews.dive_site.your_name',
    defaultMessage: 'Your name',
  },
  comments: {
    defaultMessage: 'Comments',
    id: 'comments',
  },
})

const ReviewAddForm = ({ afterSubmit, isPositive, setReviewAdded }) => {
  const intl = useIntl()
  const diveSiteId = window.locationData.diveSiteId
  const certificationLevel = window.info.account.CERTIFICATION_LEVEL

  useEffect(() => {
    connectCaptcha('captcha')
  }, [])

  const handleReviewSubmit = (data) => {
    const recaptcha = window.grecaptcha && window.grecaptcha.getResponse()

    if(recaptcha) {
      API('dive-guide/adventure-dive-site/reviews/')
        .post({
          adventureDiveSiteId: diveSiteId,
          isPositive: !!isPositive,
          recaptcha,
          ...data,
        })
        .then(() => {
          // toast.success(intl.formatMessage(messages.reviewAdded), {
          //  position: toast.POSITION.TOP_CENTER,
          // })
          setReviewAdded(true)
        })
        .finally(() => {
          afterSubmit()
        })
    } else {
      return {
        [FORM_ERROR]: [
          <FormattedMessage
            id='captcha-requred'
            defaultMessage='Captcha is required'
          />,
        ],
      }
    }
  }
  return (
    <Form
      onSubmit={handleReviewSubmit}
      validate={addingReview}
      render={({ handleSubmit, submitError, submitting }) => (
        <form className='reviews-form' onSubmit={handleSubmit}>
          <FormTextArea
            className='reviews-form__block reviews-form__textarea'
            name='text'
            rows='5'
            placeholder={intl.formatMessage(messages.placeholder)}
            isRequired
            label={messages.comments}
          />
          <FormDropDown
            name='certificationLevel'
            title={messages.certification}
            isRequired
            optionValueKey='value'
            styles={autosuggestStyles}
            options={certificationLevel}
          />
          <FormInput
            className='reviews-form__block'
            name='username'
            isRequired
            label={messages.yourName}
            placeholder={intl.formatMessage(messages.namePlaceholder)}
          />
          <div className='reviews-form__block agreement-block'>
            <FormCheckbox
              name='isOwnAgreement'
              isRequired
              label={messages.aggreement}
            />
          </div>
          <div className='mbm'>
            <div id='captcha' />
          </div>
          <div>
            {submitError &&
              submitError.map((error) => (
                <p className='server-errors' key={error}>
                  <strong className='red-text'>{error}</strong>
                </p>
              ))}
          </div>
          <button
            disabled={submitting}
            className='btn-guides-blue'
            type='submit'
          >
            <FormattedMessage
              defaultMessage='Submit review'
              id='submit_review'
            />
          </button>
        </form>
      )}
    />
  )
}

export default connect((state) => ({ reviewAdded: state.reviewAdded }), {
  setReviewAdded,
})(ReviewAddForm)
